// UnAuthProtected
import React from "react";
// import { RootState } from "../../redux/store/store";
// import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

interface Props {
  children: any;
}

const UnAuthProtected: React.FC<Props> = ({ children }) => {
  const unAuthData = sessionStorage.getItem("unAuthAddress");
//   const token = useSelector((state:RootState) => state.auth.token)
  return unAuthData && unAuthData !== "undefined" ? children : <Navigate to="/" />;
};

export default UnAuthProtected;